export default __webpack_public_path__ + "static/media/com-4.493301f8.jpeg";